module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-between"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('div', {
    attrs: {
      "id": _vm.formId
    },
    on: {
      "hileadzz_form_loaded": _vm.disableForm
    }
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.$t('ui.external_form.preview_page.forms_cannot_be_submitted')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-5 col-xl-5"
  }, [_c('div', {
    staticClass: "preview-right-box"
  }, [_c('h3', {
    staticClass: "preview-title is-margin-bottom-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.title')) + "\n      ")]), _vm._v(" "), _c('h4', {
    staticClass: "is-margin-bottom-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.head_section_title')) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "preview-paragraph"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.head_paragraph')) + "\n      ")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "preview-code",
    domProps: {
      "innerHTML": _vm._s(_vm.headCode)
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "is-margin-bottom-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.html_section_title')) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "preview-paragraph"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.html_paragraph')) + "\n      ")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "preview-code",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlCode)
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "is-margin-bottom-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.script_section_title')) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "preview-paragraph"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.script_paragraph')) + "\n      ")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "preview-code",
    domProps: {
      "innerHTML": _vm._s(_vm.scriptCode)
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-061a52f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/external_forms/ExternalFormPreview.vue
// module id = 1801
// module chunks = 0